import Vue from 'vue'
import VueRouter from 'vue-router'

import { _ENUM_CODE } from '@/utils'
import introduceLayout from '@/layouts/introduceLayout'
import robot from '@/views/introduce/robot'
import agent from '@/views/introduce/agent'
import grab from '@/views/introduce/grab'
import emAndAci from '@/views/introduce/emAndAci'
import ams from '@/views/introduce/ams'
import isf from '@/views/introduce/isf'
import cps from '@/views/introduce/cps'
import cpsqd from '@/views/introduce/cpsqd'
import vgm from '@/views/introduce/vgm'
import goodsTrack from '@/views/introduce/goodsTrack'
import shipping from '@/views/introduce/shipping'
import pushCsp from '@/views/introduce/push'
import afr from '@/views/introduce/afr'
import ics from '@/views/introduce/ics'
import mpci from '@/views/introduce/mpci'
import booking from '@/views/introduce/booking'
import Four from '@/views/introduce/four'
import EventsPage from '@/views/introduce/eventsPage'
import tracking from '@/views/tracking/index.vue'

import dynamic from '@/views/industry/dynamic'
import dynamicList from '@/views/industry/dynamicList'
import dynamicDetail from '@/views/industry/dynamicDetail'
import apiStore from '@/views/apiStore/index'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home/index.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/home/index.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/about/index.vue')
  },
  {
    path: '/tracking',
    name: 'tracking',
    component: tracking
  },

  {
    path: '/deliveryApplication',
    name: 'deliveryApplication',
    meta: { standalone: true },
    component: () => import('../views/deliveryApplication/index.vue')
  },

  {
    path: '/introduce',
    name: 'introduce',
    component: introduceLayout,
    redirect: { name: 'rpa' },
    children: [
      {
        path: 'rpa',
        name: 'rpa',
        component: robot
      },
      {
        path: 'four',
        name: 'four',
        meta: {
          code: ''
        },
        component: Four
      },
      {
        path: 'eventsPage',
        name: 'eventsPage',
        meta: {
          code: ''
        },
        component: EventsPage
      },
      {
        path: 'agent',
        name: 'agent',
        meta: {
          code: _ENUM_CODE.AGENT
        },
        component: agent
      },
      {
        path: 'grab',
        name: 'grab',
        meta: {
          code: _ENUM_CODE.ROB
        },
        component: grab
      },
      {
        path: 'emAndAci',
        name: 'emAndAci',
        meta: {
          code: _ENUM_CODE.EM
        },
        component: emAndAci
      },
      {
        path: 'ams',
        name: 'ams',
        meta: {
          code: _ENUM_CODE.AMS
        },
        component: ams
      },
      {
        path: 'isf',
        name: 'isf',
        meta: {
          code: _ENUM_CODE.ISF
        },
        component: isf
      },
      {
        path: 'cps',
        name: 'cps',
        meta: {
          code: _ENUM_CODE.SHCPS
        },
        component: cps
      },
      {
        path: 'cpsqd',
        name: 'cpsqd',
        meta: {
          code: _ENUM_CODE.QDCPS
        },
        component: cpsqd
      },
      {
        path: 'vgm',
        name: 'vgm',
        meta: {
          code: _ENUM_CODE.VGM
        },
        component: vgm
      },
      {
        path: 'track',
        name: 'track',
        meta: {
          code: _ENUM_CODE.SZTRACK
        },
        component: goodsTrack
      },
      {
        path: 'shipping',
        name: 'shipping',
        meta: {
          code: _ENUM_CODE.SCHEDULE
        },
        component: shipping
      },
      {
        path: 'push',
        name: 'push',
        meta: {
          code: 'CSP'
        },
        component: pushCsp
      },
      {
        path: 'afr',
        name: 'afr',
        meta: {
          code: _ENUM_CODE.AFR
        },
        component: afr
      },
      {
        path: 'ics',
        name: 'ics',
        meta: {
          code: _ENUM_CODE.ICS
        },
        component: ics
      },
      {
        path: 'mpci',
        name: 'mpci',
        meta: {
          code: _ENUM_CODE.MPCI
        },
        component: mpci
      },
      {
        path: 'booking',
        name: 'booking',
        meta: {
          code: _ENUM_CODE.BOOKING
        },
        component: booking
      },
      {
        path: 'apistore',
        name: 'apiStore',
        component: apiStore
      }
    ]
  },

  {
    path: '/industry',
    name: 'industry',
    redirect: { name: 'dynamicList' },
    component: dynamic,
    children: [
      {
        path: 'list',
        name: 'dynamicList',
        component: dynamicList
      },
      {
        path: 'detail/:id',
        name: 'dynamicDetail',
        component: dynamicDetail
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
